define('all/comeon',['jquery'], function ($) {
    'use strict';

    /**
     * Return a factory function that will produce new objects using the
     * prototypes that are passed in or composed.
     *
     * @param  {Object} [prototype] A map of method names that will be used as the prototype.
     * @param  {Object} [localVariables] A map of property names and values to clone for each new object.
     * @return {Object} An object map containing the fixed prototype and the properties.
     */
    function create(prototype, localVariables) {
        function F() {}
        F.prototype = prototype;
        var instance = new F();

        return $.extend(instance, localVariables);
    }

    var promise = {
        when: function (promises) {
			promises = Array.isArray(promises) ? promises : [promises];
            return $.when.apply($, promises);
        },
        create: function () {
            return $.Deferred();
        }
    };

    return {
        create: create,
        promise: promise
    };
});

